<script>

    import NewsletterButton from './NewsletterButton'

    export default {
        data () {
            return {
                author: '',
                practice: '',
                topic: ''
            }
        },
        mounted () {
            this.author = (this.defaultAuthor !== 'null') ? '/publications/author/' + this.defaultAuthor : '/publications'
            this.practice = (this.defaultPractice !== 'null') ? '/publications/practice-area/' + this.defaultPractice : '/publications'
            this.topic = (this.defaultTopic !== 'null') ? '/publications/topics/' + this.defaultTopic : '/publications'
        },
        props: [
            'defaultAuthor',
            'defaultPractice',
            'defaultTopic'
        ],
        components: {
            'newsletter-button': NewsletterButton
        },
        methods: {
            authorSelected () {
                window.location = this.author
            },
            practiceSelected () {
                window.location = this.practice
            },
            topicSelected () {
                window.location = this.topic
            },
        }
    }
</script>
